// extracted by mini-css-extract-plugin
export default {"progressBar":"ProgressBar_progressBar__Tpx4d","progress":"ProgressBar_progress__AUAMs"};